import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Initialize IndexedDB (still needed for chat stores)
import './utils/indexedDBInit';
import { environment } from './config/environment';
import {
  disableServiceWorkerCaching,
  initializePwaRegistration,
} from './services/pwaRegistrationService';

const initializeTheme = () => {
  if (typeof window === 'undefined') return;

  const storedTheme = localStorage.getItem('theme');
  const theme = storedTheme === 'dark' ? 'dark' : 'light';

  document.documentElement.classList.remove('light', 'dark');
  document.documentElement.classList.add(theme);
};

initializeTheme();

// One-time cleanup: remove legacy SW API caches
if ('caches' in window) {
  [
    'ms-graph-cache',
    'extranet-cargo-cache',
    'extranet-fixtures-cache',
    'extranet-market-data-cache',
    'extranet-operations-cache',
    'extranet-reference-data-cache',
    'extranet-admin-cache',
  ].forEach((name) => caches.delete(name));
}

// One-time cleanup: clear stale data from IndexedDB stores no longer used for caching
// Chat stores (chat, conversations, conversation-messages, llm) are preserved.
const LEGACY_CLEANUP_KEY = 'cache-removal-v1';
if (!localStorage.getItem(LEGACY_CLEANUP_KEY)) {
  localStorage.setItem(LEGACY_CLEANUP_KEY, '1');
  // Remove old localStorage fallback entries from indexedDBPersist
  Object.keys(localStorage).forEach((key) => {
    if (key.startsWith('indexeddb-fallback-zustand-')) localStorage.removeItem(key);
  });
  localStorage.removeItem('app_cache_version');
  // Clear unused IndexedDB object stores (data caches, not chat)
  const legacyStores = [
    'cargo-list',
    'cargo-count',
    'baltic',
    'bunker-prices',
    'fixed-days',
    'position-list',
    'fixtures',
    'recent-fixtures',
    'user-groups',
    'reference-data',
    'reports',
    'user',
    'theme',
    'daily-reports',
    'api-responses',
  ];
  if (window.indexedDB) {
    const req = window.indexedDB.open('extranet-cache-db');
    req.onsuccess = () => {
      const db = req.result;
      legacyStores.forEach((store) => {
        if (db.objectStoreNames.contains(store)) {
          try {
            const tx = db.transaction(store, 'readwrite');
            tx.objectStore(store).clear();
          } catch {
            /* store may not exist in this version */
          }
        }
      });
      db.close();
    };
  }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    if (!environment.pwa.enabled) {
      disableServiceWorkerCaching().catch(() => {
        // Service worker disable failed
      });
      return;
    }

    initializePwaRegistration();
  });
}
